import React from "react";
import { ROADMAP } from "../../../utils/niftyData";

const stLabel: Record<string, string> = {
  shipped: "SHIPPED",
  active: "IN FLIGHT",
  next: "QUEUED",
  horizon: "HORIZON",
};

export default function Roadmap() {
  const rm = ROADMAP;
  return (
    <section id="roadmap" className="sec-pad" data-screen-label="Roadmap">
      <div className="wrap">
        <div className="sec-tag">
          <span className="idx">[ 07 ]</span> MISSION TIMELINE <span className="rule"></span> <span>TRAJECTORY</span>
        </div>
        <div className="rm-track">
          <div className="rm-line"></div>
          {rm.map((p, i) => (
            <div
              className={"rm-node rm-" + p.st}
              data-reveal
              key={i}
              style={{ transitionDelay: i * 80 + "ms" }}
            >
              <div className="rm-marker"></div>
              <div className="rm-ph mono">{p.ph}</div>
              <div className="rm-t">{p.t}</div>
              <div className="rm-st mono">{stLabel[p.st]}</div>
              <div className="rm-d">{p.d}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
